import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpService {

    constructor(private http: HttpClient) { }

    get(url: string, options?: any): Observable<any> {
        return this.http.get<any>(url, options);
    }

    request(url: string, method: string, options: any): Observable<any> {
        return this.http.request<any>(method, url, options);
    }

    private catchErrors() {
        return (res: Response) => {
            if (res.status === 401 || res.status === 440) {
                //this.router.navigate(['/login']);
            }

            return Observable.throw(res);
        };
    }
}
